import { api } from '@/utils/api';
import { InfrastructureHealthResponse, SourcesKpisHealth } from './HealthTypes';

export default class HealthRepository {
	async getSourcesKpisHealth(): Promise<SourcesKpisHealth> {
		const response = await api.get('/dashboards/health/sourcesKpis');
		return response.data;
	}

	async getInfrastructuresHealth(
		page: number,
		size: number,
		parameterId?: number,
		search?: string,
	): Promise<InfrastructureHealthResponse> {
		const params: { page: number; size: number; parameterId?: number; search?: string } = {
			page,
			size,
		};
		if (parameterId) {
			params.parameterId = parameterId;
		}
		if (search) {
			params.search = search;
		}

		const response = await api.get(`/dashboards/health/infrastructures`, {
			params,
		});
		return response.data as InfrastructureHealthResponse;
	}
}
